module.exports = __webpack_public_path__ + "img/logo.6a02ad53.svg";